module.exports = __webpack_public_path__ + "static/logo-pbtech-0646647e58eab654f82696f0ca84a1b3.png";